import React from 'react';
import { connect } from 'react-redux';
import _intersection from 'lodash/intersection';
import injectIntl, { intlShape } from 'common/injectIntl';
import ScheduleModuleContainer from 'scheduleModule/ScheduleModuleContainer';
import { BucketLayout, BucketStatus, PageType } from 'enums';
import Bucket from './Bucket';

function isHeroBucket(bucket) {
    return bucket.type === 'hero';
}

function insertScheduleModuleIntoBuckets(buckets, pageType) {
    const clonedBuckets = buckets.slice();
    // on the home page, find the live bucket, and insert the schedule module right after it
    if (pageType === PageType.HOME) {
        let insertIndex = -1;
        buckets.forEach((bucket, index) => {
            const { tags = [] } = bucket;
            if (tags.indexOf(BucketStatus.WEB_LIVE) !== -1) {
                insertIndex = index;
            }
        });
        // if we found the live buckets, insert right after it, otherwise, push it on the end
        if (insertIndex !== -1) {
            clonedBuckets.splice(insertIndex + 1, 0, { __schedule_module_placeholder__: true });
            return clonedBuckets;
        }
    }

    clonedBuckets.push({ __schedule_module_placeholder__: true });
    return clonedBuckets;
}

// these are the buckets we don't want to render below the hero
const excludeTags = [BucketLayout.HERO, BucketLayout.SCHEDULE_MODULE];

const BucketListContainer = ({
    buckets,
    heroContentId,
    layoutOverride,
    pageType,
    messages,
    intl: { formatMessage }
}) => {
    const curatedBuckets = insertScheduleModuleIntoBuckets(buckets.filter((bucket) => !isHeroBucket(bucket)), pageType);
    let tapestryCount = 0;

    return (
        <div>
            {curatedBuckets.map((bucket) => {
                // inserts the schedule module into a mobile only container depending on what page we're on
                if (bucket.__schedule_module_placeholder__ === true) {
                    return <div className="mobile-tablet-only"><ScheduleModuleContainer contentLimit={3} /></div>;
                }

                // don't render the hero here if it was returned as a bucket from the page api
                if ((bucket.contents.length === 1 && bucket.contents[0].id === heroContentId)
                    || (bucket.tags && _intersection(excludeTags, bucket.tags).length > 0)) {
                    return null;
                }

                // get the layout from bucket
                let layoutType = BucketLayout[bucket.layout] || BucketLayout.DEFAULT;

                // override layout based on page
                switch (pageType) {
                    case PageType.COLLECTION:
                        layoutType = BucketLayout.COLLECTION;
                        break;
                    case PageType.FEATURES:
                        layoutType = (tapestryCount % 2 === 0 ? BucketLayout.TAPESTRY_LEFT : BucketLayout.TAPESTRY_RIGHT);
                        tapestryCount += 1;
                        break;
                    default:
                        break;
                }

                // sometimes, we want to defy all convention and alter the layout
                if (layoutOverride) {
                    layoutType = layoutOverride;
                }

                // make the link relative by chopping off the host
                const link = bucket.links.web && bucket.links.web.replace(/https?:\/\/[^\/]*(?:\/watch)?/, '');
                const bucketId = bucket.metadata.bucketId || bucket.id;
                const groupId = bucket.metadata.groupId;
                return (
                    <Bucket
                        bucketId={bucketId}
                        contents={bucket.contents}
                        groupId={groupId}
                        heroContentId={heroContentId}
                        iconHref={bucket.iconHref}
                        key={bucket.id}
                        layoutType={layoutType}
                        link={link}
                        metadata={bucket.metadata}
                        name={bucket.name}
                        pageType={pageType}
                        tags={bucket.tags}
                        type={bucket.type}
                        liveLabel={formatMessage(messages.live)}
                    />
                );
            })}
        </div>
    );
};

BucketListContainer.propTypes = {
    buckets: React.PropTypes.array,
    heroContentId: React.PropTypes.number,
    pageType: React.PropTypes.string,
    layoutOverride: React.PropTypes.string,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

BucketListContainer.defaultProps = {
    buckets: [],
    isCollectionPage: false,
    isFeaturesPage: false
};

const mapStateToProps = (state) => ({
    buckets: (state.page && state.page.buckets) || [],
    heroContentId: state.page.hero && state.page.hero.id
});

export default connect(mapStateToProps)(injectIntl(BucketListContainer));



// WEBPACK FOOTER //
// ./app/page/buckets/BucketListContainer.js